import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTargetBrandConfig } from 'FrontRoyalAngular';
import { useErrorLogService } from 'ErrorLogging';
import { Button } from 'Button';
import FrontRoyalSpinner from 'FrontRoyalSpinner';
import frontRoyalStoreProvider from 'FrontRoyalStore/frontRoyalStoreProvider';
import { showToast } from 'Toast';
import { SettingRow } from './SettingRow';

// Experimental action that wipes and rebuilds the local IndexedDB store. Only shown
// for branded (non-whitelabel) contexts, matching the old `ng-if="brandNameShort"`.
export function ClearLocalDatabaseRow() {
    const { t } = useTranslation('back_royal');
    const { brandNameShort } = useTargetBrandConfig();
    const ErrorLogService = useErrorLogService();
    const [clearingLocalDatabase, setClearingLocalDatabase] = useState(false);

    if (!brandNameShort) return null;

    const clearLocalDatabase = async () => {
        setClearingLocalDatabase(true);
        try {
            await frontRoyalStoreProvider.get()?.reinitializeDb();
            showToast({ message: t('settings.edit_preferences.database_cleared'), type: 'success' });
        } catch (error) {
            ErrorLogService.notify('Failed to clear local database', error);
        } finally {
            setClearingLocalDatabase(false);
        }
    };

    return (
        <SettingRow
            className="clear-local-database-section"
            title={t('settings.edit_preferences.experimental')}
            description={t('settings.edit_preferences.warning_only_use_if_instructed', { brandName: brandNameShort })}
        >
            {clearingLocalDatabase ? (
                <FrontRoyalSpinner className="no-delay no-top-margin inline" />
            ) : (
                <Button
                    variant="bordered-white-light"
                    color="black"
                    height={9}
                    fontWeight="normal"
                    onPress={clearLocalDatabase}
                >
                    {t('settings.edit_preferences.clear_local_db')}
                </Button>
            )}
        </SettingRow>
    );
}
